import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { buildVersion } from '../../../environments/version';

export const cpoVersionInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
) => {
  const isAzureBlobRequest = req.url.includes('blob.core.windows.net');

  if (isAzureBlobRequest) {
    return next(req);
  }

  return next(
    req.clone({
      headers: req.headers.set('x-cpo-version', buildVersion.version),
    })
  );
};
